module.exports = __webpack_public_path__ + "static/st2-7-ee8571bb5a5e6194eb1192f1e3fd5dea.jpg";